export const COLORS = {
  PRIMARY_COLOR: "#a8bdc3",
  DARK_PRIMARY_COLOR: "#7f8f94",
  SECONDARY_COLOR: "#cfe7d7",
  ACCENT_COLOR: "#37505C",
  TEXT_PRIMARY_COLOR: "#201e1d",
  TEXT_SECONDARY_COLOR: "#9ba3a7",
  HIGHLIGHT_COLOR: "#e4e1dc",
};
